module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_gallery_addto_favorite", [["a",{"class":"fav-link bookmark pointer","data-target-id":""},[["if",{"notempty":"","addclass":"active"},[],[["isFavorite","notempty",true]]],["if",{"empty":"","addattr":"href:&&1&&"},[],[["id","empty",true,[],"member"],["siteProps.ubs.joinUrl","__internal",false,[],"env"]]],["i",{"class":"icon-au_favorites"}],["textNode",{"text":" "}],["span",{"class":"action-link-text"},[["textNode",{"text":"ADD TO FAVORITES"}]]]],[["targetId","data-target-id",true]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/social/favorite.tpl
// module id = 1248
// module chunks = 4